import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import AbroadSeparatedSaleBlockData from '../../../Models/Content/AbroadSeparatedSaleBlockData';
import SeparatedSaleMain from '../CellcomAbroadLobbyBlock/separatedSale/separatedSaleMain';


export default class AbroadTicket extends EpiComponent<AbroadSeparatedSaleBlockData>
{
    constructor(props) {
        super(props);  
    }

    public render() : ReactNode | ReactNodeArray | null
    {
        const context = this.getContext();
        const iContent = this.props.data;

        return (
            <SeparatedSaleMain context={context} iContent={iContent}/>    
        );
    }
}
